<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { incomeExpense } from "../../../../services/financeservice/incomeExpense.service";
// import { propertyService } from "../../../../services/propertyservice/property.service";
import { projectService } from "../../../../services/projectservice/project.service";
import { servicehelpers } from "../../../../services/servicehelpers";"../../../../services/propertyservice/property.service";

import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Expense List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      expenseList: {},
      fetchingStats: false,
      title: "ExpenseTemplates List",

    };
  },
  mounted() {
    
    this.loadingData();
    this.loadingprojectData();
  },

  methods: {
    loadingData: function(param = '') {
      // param = `?page=0&clause={"clause":[{"conjuction":"and","income_expenses.type":{"value":2}}]}`;
      let uri = `&clause={"clause":[{"conjuction":"and","income_expenses.type":{"value":2}}]}`;
      param = param ? param + uri : `?page=1`+uri;

      this.fetchingStats = false;
      incomeExpense.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.expenseList = response;
        });
    },

    projectChanged: function(event) {
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

        });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    deleted: function(id) {
      incomeExpense.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "expense-add",
          });
    },

  }
};

// v-bind:edit="{link: 'expense-edit'}"
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'expense.add', link: 'expense-add'}" :title="$t('expense.text')" />
    <List v-bind:dataList="expenseList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:deletes="[deleted, null]"
          v-bind:formats="[
            {name: 'item'}, 
            {name: 'for_date', type: 'date'},
            {name: 'amount', type: 'currency', sign: '$'}, 
          ]"
          v-bind:fields="[ 
            `project_code: ${$t('project.text')}`,
            `supplier_name_en: ${$t('supplier.text')}`,
            `ref_no: ${$t('expense.ref_no')}`,
            `for_date: ${$t('expense.date')}`,
            `amount: ${$t('expense.amount')}`,
            `item: ${$t('expense.item-type')}`,
            `notation: ${$t('expense.notation')}`
          ]"
          
          v-bind:filter="{
            search: ['income_expenses.ref_no'],
            dropdown:[],
            date: {
              title: 'general.date',
              field: 'sales.for_date'
            }
          }"
          
    />      
  </Layout>
</template>